'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Quote API
 */
var Quote = function (_CoveAPI) {
  (0, _inherits3.default)(Quote, _CoveAPI);

  /**
   * Creates a new Quote API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Quote(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Quote);
    return (0, _possibleConstructorReturn3.default)(this, (Quote.__proto__ || (0, _getPrototypeOf2.default)(Quote)).call(this, host, 'quote/v1', environment, auth));
  }

  /**
   * Creates a new quote then returns the quote
   * @param {*} risk
   * @param {*} customer
   * @param {string} start_date
   * @param {string} referral
   */


  (0, _createClass3.default)(Quote, [{
    key: 'create',
    value: function create(risk, customer, start_date, referral_code, additionalAttributes) {
      var payment_frequency = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'monthly';

      var coverage = {
        risk: risk,
        start_date: start_date
      };

      var body = {
        quote: {
          referral_code: referral_code,
          additionalAttributes: additionalAttributes,
          customer: customer,
          payment_frequency: payment_frequency,
          coverages: [coverage]
        }
      };

      return this.apiClient.fetch('POST', 'create', null, body).then(function (data) {
        return data.quote;
      });
    }

    /**
     * Gets and returns the quote
     * @param {string} quote_id
     */

  }, {
    key: 'retrieve',
    value: function retrieve(quote_id) {
      return this.apiClient.fetch('GET', 'retrieve', { quote_id: quote_id }).then(function (data) {
        return data.quote;
      });
    }
  }, {
    key: 'retrieveByCoverage',
    value: function retrieveByCoverage(coverage_id) {
      return this.apiClient.fetch('GET', 'retrieveByCoverage', { coverage_id: coverage_id });
    }

    /**
     * Queries the quotes by customer_id
     * @param {string} customer_id
     * @param {string} quote_status
     */

  }, {
    key: 'queryByCustomerId',
    value: function queryByCustomerId(customer_id, quote_status) {
      return this.apiClient.fetch('GET', 'queryByCustomer', { customer_id: customer_id, quote_status: quote_status }).then(function (data) {
        return data.quotes;
      });
    }
  }, {
    key: 'updateAdditionalAttributes',
    value: function updateAdditionalAttributes(body) {
      // body must contain quote_id or coverage_id
      return this.apiClient.fetch('POST', 'updateAdditionalAttributes', null, body);
    }

    /**
     * Updates then returns the updated quote
     * @param {*} quote
     */

  }, {
    key: 'update',
    value: function update(quote) {
      return this.apiClient.fetch('POST', 'update', null, { quote: quote }).then(function (data) {
        return data.quote;
      });
    }

    /**
     * Binds the quote then returns a the full response
     * @param {*} quote_id
     * @param {*} payment
     * @returns {{coverage: Object, cognitoAuthentication: Object}}
     */

  }, {
    key: 'bind',
    value: function bind(quote_id, payment) {
      return this.apiClient.fetch('POST', 'bind', null, {
        quote: { quote_id: quote_id },
        payment: payment
      });
    }

    /**
     * Binds a quote from Stripe payment then returns a the full response
     * @param {*} quote_id
     * @param {*} paymentIntent
     * @param {*} paymentMethod
     * @returns {{coverage: Object, cognitoAuthentication: Object}}
     */

  }, {
    key: 'bindQuoteStripe',
    value: function bindQuoteStripe(quote_id, paymentIntent, paymentMethod) {
      return this.apiClient.fetch('POST', 'bindQuoteStripe', null, {
        quote: { quote_id: quote_id },
        paymentIntent: paymentIntent,
        paymentMethod: paymentMethod
      });
    }

    /**
     * Cancels the quote/future policy
     * @param {*} body
     */

  }, {
    key: 'cancel',
    value: function cancel(body) {
      return this.apiClient.fetch('POST', 'cancel', null, body).then(function (data) {
        return data.quote;
      });
    }
  }]);
  return Quote;
}(_CoveApi2.default);

exports.default = Quote;